<template>
  <div class="input-wrap">
      <textarea name="stringInput" id="string-input"></textarea><br>
      <button @click="countIt()">Count it!</button>
  </div>
</template>

<script>
import Counter from '@/services/Counter.js';

export default {
    name: 'StringInput',
    methods: {
        countIt(array) {
            let string = document.querySelector("#string-input").value;
            let answer = new Counter(string);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let newLoad = new Counter('This is the first load.');
})
</script>

<style>
#string-input {
    max-width: 500px;
    width: 90%;
    border: 2px solid #123321;
    border-radius: 10px;
    padding: 10px;
}

@import url('https://fonts.googleapis.com/css2?family=Bangers&family=Pacifico&display=swap');

.input-wrap button {
    margin: 20px auto;
    color: #FFFFFF;
    padding: 14px 20px;
    border-radius: 15px;
    border: 6px solid #FFFFFF;
    background-color: #42b983;
    font-size: 1.1rem;
    font-family: "Pacifico", cursive;
    transition: ease-in-out .3s all;
}

.input-wrap button:hover {
    box-shadow: 10px 10px 0px #aeaeae;
}

</style>